import { CLASSIFICATION_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';

const HCP_PROFESSION_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.adoption`],
  limit: undefined,
});

const adoptionRatingFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.adoptionRatingLabel',
  sourceCube: CLASSIFICATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: HCP_PROFESSION_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${CLASSIFICATION_CUBE_NAME}.adoption`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.adoptionRatingLabelPlaceholder',
  searchable: true,
  applyFilter: adoptionFilterValue => {
    let adoptionValues: string[] = [];

    if (Array.isArray(adoptionFilterValue)) {
      adoptionValues = adoptionFilterValue.filter((entry): entry is string => typeof entry === 'string');
    } else if (typeof adoptionFilterValue === 'string') {
      adoptionValues = [adoptionFilterValue];
    }

    return {
      member: `${CLASSIFICATION_CUBE_NAME}.adoption`,
      operator: 'equals',
      values: adoptionValues,
    };
  },
};

export default adoptionRatingFilter;
